import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=5e0a47e5&"
import script from "./select-input.vue?vue&type=script&lang=js&"
export * from "./select-input.vue?vue&type=script&lang=js&"
import style0 from "./select-input.vue?vue&type=style&index=0&id=5e0a47e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports